<app-nav-home-student *ngIf="!loading" [linkId]="100" [learner]='learner'></app-nav-home-student>
<!--Link Id above links such that all are available-->
<div class="card"  *ngIf="!loading">
<div class="card-header">
  <div class="alert alert-primary text-center"> <b>Your  Overall Score is {{quizEnvelop.score}}%</b><hr/>
    <app-star-rating [score]="quizEnvelop.score" *ngIf="quizEnvelop.server_quiz_envelop_id!=0"></app-star-rating>
  </div>
</div>
<div class="card-body">
  <h4 *ngIf="renderMathNow" [appMath]="title" class="text-center"> </h4>
  <table class="table table-striped table-borderless quiz-reslut">
      <thead>
      <tr class="qbodyText">
          <th > Question </th>
          <th> Result </th>
          <th> Details </th>
        </tr>
      </thead>

        <tbody>

          <tr *ngFor="let question of quizEnvelop.questions; index as myCount">
            <td>
            <div class="qbodyText">
            {{question.questionIndex+1}}.
            <a [routerLink]="['/student/quiz/revise',server_student_user_id,quizEnvelop.server_quiz_envelop_id,question.server_question_id,question.questionIndex]" [innerHTML]="question.questionText">

            </a>
            </div>
            </td>
         <td class="text-center align-middle">
          <a [routerLink]="['/student/quiz/revise',server_student_user_id,quizEnvelop.server_quiz_envelop_id,question.server_question_id,question.questionIndex]">
              <span *ngIf="question.is_correct" >
              <img src="/assets/images/happy-smiley.png" width="40px"/>
              <p><i class="fa fa-check text-success"></i></p>
          </span>
          <span *ngIf="!question.is_correct">
              <img  src="/assets/images/unhappy-smiley.png" width="40px"/>
              <p><i class="fa fa-close text-danger"></i></p>
          </span>
          </a>
        </td>

         <td class="text-center align-middle">
          <a [routerLink]="['/student/quiz/revise',server_student_user_id,quizEnvelop.server_quiz_envelop_id,question.server_question_id,question.questionIndex]" >
            Details
          </a>
        </td>
      </tr>
    </tbody>
      </table>
</div>
<div class="card-footer text-center align-middle">

    <a [routerLink]= "['/student/show', server_student_user_id]"
       class="btn btn-primary btn-lg"><i class="fa fa-home"></i> Home
    </a>

</div>
</div>
<app-spinner   *ngIf="loading"></app-spinner>






